<h1 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 text-center">Purchase Order Details</h1>

<form [formGroup]="transactionDetails" class="flex flex-col">
  <div class="flex flex-1 my-3 gap-6">
    <div class="relative flex-1">
      <app-pan-floating-label [required]="true">Internal PO</app-pan-floating-label>
      <input
        formControlName="internal_po"
        key
        required
        panInput
        [color]="transactionDetails.controls.internal_po.value ? 'default' : 'danger'"
      />
    </div>

    <div class="relative flex-1">
      <app-pan-floating-label>Customer PO</app-pan-floating-label>
      <input formControlName="customer_po" key required panInput />
    </div>
  </div>

  <div class="flex flex-1 my-3 gap-6">
    <div class="relative flex-1">
      <app-pan-floating-label>Needs To Be Shipped By</app-pan-floating-label>
      <app-pan-datepicker [(date)]="transactionDetails.controls.ship_by.value!"></app-pan-datepicker>
    </div>

    <div class="relative flex-1">
      <app-pan-floating-label>Shipping Notes</app-pan-floating-label>
      <textarea panTextarea rows="6" formControlName="shipping_notes" key required></textarea>
    </div>
  </div>
</form>

<div class="flex gap-6">
  <div class="flex-1">
    <h2 class="mb-2 text-xl font-bold tracking-tight text-gray-900 text-center">Bundles</h2>

    <ag-grid-angular
      [rowData]="bundles()"
      [columnDefs]="bundleColumnDefs"
      [gridOptions]="bundleTableDef"
      [loading]="isLoading()"
    ></ag-grid-angular>
  </div>

  <div class="flex-1">
    <h2 class="mb-2 text-xl font-bold tracking-tight text-gray-900 text-center">Cart</h2>

    <ag-grid-angular
      [rowData]="cart()"
      [columnDefs]="cartColumnDefs"
      [gridOptions]="cartTableDef"
      [loading]="isLoading()"
    ></ag-grid-angular>
  </div>
</div>

<div class="flex gap-6">
  <div class="flex-1"></div>
  <div class="flex-1 flex justify-end p-3">
    <!-- compute cart quantity, price total of all -->
    <app-pan-button
      color="success"
      fill="outline"
      icon="shopping_cart"
      (click)="checkout()"
      [disabled]="!isFormValid() || saving()"
      [state]="saving() ? 'loading' : 'default'"
    >
      Checkout
    </app-pan-button>
  </div>
</div>
